<template>
      <el-row>
        <el-col>
          <el-menu default-active="1" class="el-menu-vertical-demo" background-color="#545c64" text-color="#fff" active-text-color="#ffd04b"  :style="{height:navHeight+'px'}" :router="true">
              <h1 style="padding-left:25px;"><img src="../assets/logo.png" width="130px"></h1>
              <h1><br><br></h1>
			 
              <el-menu-item index="1" :route="{path:'/'}">
                <i class="el-icon-menu"></i>
                <span>首页</span>
              </el-menu-item>
              <el-menu-item index="2" :route="{path:'/mall'}" v-if="isshop==1">
                <i class="el-icon-goods"></i>
                <span>线上商城管理</span>
              </el-menu-item>
              <el-menu-item index="3" :route="{path:'/stat'}">
                <i class="el-icon-tickets"></i>
                <span slot="title">统计查询</span>
              </el-menu-item>
              <el-menu-item index="4" :route="{path:'/shop'}" v-if="isshop==1 && groupid==1">
                <i class="el-icon-view"></i>
                <span>店铺管理</span>
              </el-menu-item>
              <el-menu-item index="5" :route="{path:'/base'}">
                <i class="el-icon-news"></i>
                <span>信息管理</span>
              </el-menu-item>
              <el-menu-item index="6" :route="{path:'/config'}">
                <i class="el-icon-setting"></i>
                <span>系统设置</span>
              </el-menu-item>
              <el-menu-item index="7" @click="onExit">
                <i class="el-icon-info"></i>
                <span slot="title">退出系统</span>
              </el-menu-item>
          </el-menu>
        </el-col>
      </el-row>     
</template>

<script>
export default {
  data () {
    return {
      navHeight:'',
      isshop:2,
      groupid:'',
      menu:[],
    }
  },
  mounted(){
    var clientHeight = document.documentElement.clientHeight;
    var scrollHeight = document.body.scrollHeight;
    if(scrollHeight > clientHeight){
      this.navHeight = scrollHeight;
    }else{
      this.navHeight = clientHeight;
    }
    const that = this;
    window.onresize = function temp() {
        //that.navHeight = document.documentElement.clientHeight;
      var clientHeight = document.documentElement.clientHeight;
      var scrollHeight = document.body.scrollHeight;
      if(scrollHeight > clientHeight){
        that.navHeight = scrollHeight;
      }else{
        that.navHeight = clientHeight;
      }
    };
    this.checkLogin();
    this.getreadshop();
    this.getGroup();
  },
  methods:{
    checkLogin(){
      if(!this.$cookies.isKey("token")){
        this.$router.push('/login')
      }
    },
    onExit(){
      var token=this.$cookies.get("token");
      this.$http.post(this.GLOBAL.domain+"login/index.html",{"token":token,"act":"logout"}).then(res=>{
        if(res.body.Result > 0){
          this.$message.error(res.body.Message);
        }else{
          this.$cookies.remove("token");
          this.$message({
            message: res.body.Message,
            type: 'success'
          });
          this.$router.push('/login')
        }
      });
    },
    
    //获取当前用户是否有查看店铺管理的资格
    getreadshop() {
        var token=this.$cookies.get("token");
        this.$http.post(this.GLOBAL.domain+"Shop/index.html",{"token":token,"act":"isread"}).then(res=>{
        	this.isshop=Base64.decode(res.body.Data);
        });
    },
    
    //获取当前用户是否有查看店铺管理的资格
    getGroup() {
        var token=this.$cookies.get("token");
        var id=this.$cookies.get("groupid");
        this.$http.post(this.GLOBAL.domain+"Shop/index.html",{id:id,"token":token,"act":"isgroup"}).then(res=>{
        	this.groupid=Base64.decode(res.body.Data);
        });
    },
    
    
  },
   
}
</script>


// WEBPACK FOOTER //
// src/components/Left.vue